import {
  isDateRangeFilter,
  setDateValidationErrors,
} from '@user/components/Filters'
import { ILead, LeadFilterSet } from '@user/store/lead'
import { FormikErrors } from 'formik'

export function validateLeadFilters(values: LeadFilterSet) {
  const { filters } = values

  const errors: FormikErrors<LeadFilterSet> = {}
  for (const filter in filters) {
    if (isDateRangeFilter<ILead>(filters[filter])) {
      setDateValidationErrors(filters[filter], errors)
    }
  }

  return errors
}
